export default {
    AddFeedback: (data) => window.axios.post('add-feedback',data)
}